import script from "./ITEM_DEMO_VIDEO.vue?vue&type=script&setup=true&lang=ts"
export * from "./ITEM_DEMO_VIDEO.vue?vue&type=script&setup=true&lang=ts"

import "./ITEM_DEMO_VIDEO.vue?vue&type=style&index=0&id=27530b7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27530b7d"]])

export default __exports__